
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5etuL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $d3MrN = parcelRequire("d3MrN");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7J5Uc = parcelRequire("7J5Uc");





var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");


var $l1b8J = parcelRequire("l1b8J");


var $hMdkB = parcelRequire("hMdkB");

const $a1ce8cd657fbddc0$export$2a648297aa723519 = ({ contentId: contentId, spaceKey: spaceKey })=>{
    const { isPresenterModeActive: isPresenterModeActive, isBrowserFullscreen: isBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    if (isPresenterModeActive || isBrowserFullscreen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMdkB.PresenterModePortal), {
            contentId: contentId,
            spaceKey: spaceKey,
            setFlagsVisibility: flags.setFlagsVisibility
        }));
    return null;
};





const $347dae9f98a90854$export$d9be451d5ed0cecd = ({ children: children, contentId: contentId, spaceKey: spaceKey })=>{
    const [isPresenterModeActive, setIsPresenterModeActive] = (0, $cozmU.useState)(false);
    const [isBrowserFullscreen, setIsBrowserFullscreen] = (0, $cozmU.useState)(false);
    const [presenterModeContextError, setPresenterModeContextError] = (0, $cozmU.useState)(null);
    const [hasEnteredPresentMode, setHasEnteredPresentMode] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { restoreThemePreference: restoreThemePreference } = (0, $7J5Uc.useThemingActions)();
    const enterBrowserFullscreen = (0, $cozmU.useCallback)(()=>{
        setIsBrowserFullscreen(true);
    }, []);
    const handleFullScreenApiError = (0, $cozmU.useCallback)((error)=>{
        enterBrowserFullscreen();
        setPresenterModeContextError(error);
    }, [
        setPresenterModeContextError,
        enterBrowserFullscreen
    ]);
    const fscreenRequestFullscreen = (0, $cozmU.useCallback)(()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        return Promise.resolve((0, $d3MrN.default).requestFullscreen(document.documentElement));
    }, []);
    const fscreenExitFullscreen = (0, $cozmU.useCallback)(()=>{
        return Promise.resolve((0, $d3MrN.default).exitFullscreen());
    }, []);
    const isPresenterModeEnabled = (0, $d3MrN.default).fullscreenEnabled;
    const enterPresenterMode = (0, $cozmU.useCallback)(()=>{
        setHasEnteredPresentMode(true);
        experienceTracker.start({
            name: (0, $irVI7.PRESENTER_MODE_FULLSCREEN_API_EXPERIENCE)
        });
        (0, $d3MrN.default).addEventListener('fullscreenerror', handleFullScreenApiError, false);
        setIsPresenterModeActive(true);
        setPresenterModeContextError(null);
        if (!isPresenterModeEnabled) {
            const error = new Error('Fullscreen mode is not supported');
            handleFullScreenApiError(error);
            enterBrowserFullscreen();
            return;
        }
        if ((0, $d3MrN.default).fullscreenElement) fscreenExitFullscreen().then(fscreenRequestFullscreen).then(()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
            });
        }).catch(enterBrowserFullscreen);
        else fscreenRequestFullscreen().then(()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
            });
        }).catch(enterBrowserFullscreen);
    }, [
        experienceTracker,
        fscreenRequestFullscreen,
        isPresenterModeEnabled,
        fscreenExitFullscreen,
        handleFullScreenApiError,
        enterBrowserFullscreen,
        setHasEnteredPresentMode
    ]);
    const enterSystemFullscreen = (0, $cozmU.useCallback)(()=>{
        setIsBrowserFullscreen(false);
        enterPresenterMode();
    }, [
        enterPresenterMode
    ]);
    const exitPresenterMode = (0, $cozmU.useCallback)(()=>{
        setIsPresenterModeActive(false);
        (0, $d3MrN.default).removeEventListener('fullscreenerror', handleFullScreenApiError, false);
        restoreThemePreference();
    }, [
        setIsPresenterModeActive,
        handleFullScreenApiError,
        restoreThemePreference
    ]);
    const data = (0, $cozmU.useMemo)(()=>({
            isPresenterModeActive: isPresenterModeActive,
            isBrowserFullscreen: isBrowserFullscreen,
            hasEnteredPresentMode: hasEnteredPresentMode,
            enterPresenterMode: enterPresenterMode,
            exitPresenterMode: exitPresenterMode,
            isPresenterModeEnabled: isPresenterModeEnabled,
            presenterModeContextError: presenterModeContextError,
            setPresenterModeContextError: setPresenterModeContextError,
            enterBrowserFullscreen: enterBrowserFullscreen,
            setIsBrowserFullscreen: setIsBrowserFullscreen,
            enterSystemFullscreen: enterSystemFullscreen,
            setHasEnteredPresentMode: setHasEnteredPresentMode
        }), [
        isPresenterModeActive,
        isBrowserFullscreen,
        hasEnteredPresentMode,
        enterPresenterMode,
        exitPresenterMode,
        isPresenterModeEnabled,
        presenterModeContextError,
        setPresenterModeContextError,
        enterBrowserFullscreen,
        setIsBrowserFullscreen,
        enterSystemFullscreen,
        setHasEnteredPresentMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1b8J.PresenterModeContext).Provider, {
        value: data
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1ce8cd657fbddc0$export$2a648297aa723519), {
        contentId: contentId,
        spaceKey: spaceKey
    }));
};
const $347dae9f98a90854$export$530d225c8bef9444 = ({ children: children })=>{
    const { enterPresenterMode: enterPresenterMode } = (0, $l1b8J.usePresenterModeContext)();
    return children(enterPresenterMode);
};
module.exports["PresenterModeContextProvider"] = $347dae9f98a90854$export$d9be451d5ed0cecd;
module.exports["PresenterModeContextConsumer"] = $347dae9f98a90854$export$530d225c8bef9444;

});

parcelRegister("hMdkB", function(module, exports) {
/**
 * @generated SignedSource<<0249018a616de758b0f652bd2ee9dca9>>
 * @relayHash de4d9d686320df3885759997cb1dea1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 596432b3fe72e76dfac96d97bcdd00fadb3129b5e172d978a8692f0079b1c431
const $43087a03fe0f39ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PresenterModePortalPresenterModeCoverPictureQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PresenterModePortalPresenterModeCoverPictureQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "de4d9d686320df3885759997cb1dea1b",
            "id": "596432b3fe72e76dfac96d97bcdd00fadb3129b5e172d978a8692f0079b1c431",
            "metadata": {},
            "name": "PresenterModePortalPresenterModeCoverPictureQuery",
            "operationKind": "query",
            "text": "query PresenterModePortalPresenterModeCoverPictureQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$43087a03fe0f39ae$var$node.hash = "06d34d781803b4e8c4ff1a93ae7349df";
var $43087a03fe0f39ae$export$2e2bcd8739ae039 = $43087a03fe0f39ae$var$node;


/**
 * @generated SignedSource<<effa270f732243c74762ffd31141ca90>>
 * @relayHash 71650dfb167b5e53344553c052814f35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8784ffad5fb2dc131a0387a6140976fd26edfa297aa6c8b24de67ea4b167b55d
const $0cb2cdb46393f11b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "alias": "emojiTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"emoji-title-published\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PresenterModePortalPresenterModeContentTitleQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PresenterModePortalPresenterModeContentTitleQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "71650dfb167b5e53344553c052814f35",
            "id": "8784ffad5fb2dc131a0387a6140976fd26edfa297aa6c8b24de67ea4b167b55d",
            "metadata": {},
            "name": "PresenterModePortalPresenterModeContentTitleQuery",
            "operationKind": "query",
            "text": "query PresenterModePortalPresenterModeContentTitleQuery($contentId:ID!){content(id:$contentId){nodes{id,title,emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value}}}}}"
        }
    };
}();
$0cb2cdb46393f11b$var$node.hash = "bb4f3c014152c410cb5600c2a10111e8";
var $0cb2cdb46393f11b$export$2e2bcd8739ae039 = $0cb2cdb46393f11b$var$node;


/**
 * @generated SignedSource<<ae828fd914e7407dae64b7f293ba8e58>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $78439205b7877f59$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PresenterModePortal_content",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "keys",
                    "value": [
                        "cover-picture-id-published",
                        "emoji-title-published",
                        "editor",
                        "import-source",
                        "imported-page-modified-date"
                    ]
                }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JsonContentProperty",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
        }
    ],
    "type": "Content"
};
$78439205b7877f59$var$node.hash = "32009a58e11b994a0a956b61ff15cbc6";
var $78439205b7877f59$export$2e2bcd8739ae039 = $78439205b7877f59$var$node;



var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d3MrN = parcelRequire("d3MrN");


var $1enXm = parcelRequire("1enXm");


var $6SsN4 = parcelRequire("6SsN4");


var $cK21K = parcelRequire("cK21K");


var $lfoFx = parcelRequire("lfoFx");


var $jMyy4 = parcelRequire("jMyy4");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $8rneB = parcelRequire("8rneB");


var $di8q4 = parcelRequire("di8q4");


var $e8Lxy = parcelRequire("e8Lxy");

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $jmjWc = parcelRequire("jmjWc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fa2236fe735b9be$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0jFU0VN91d _39xV02N91d",
            __cmplp.className
        ])
    });
});
const $2fa2236fe735b9be$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2fa2236fe735b9be$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large"
    }));

const $2fa2236fe735b9be$export$c545dc5a218e1111 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mUAtU",
    name: "LazyQRCodeGenerator",
    loader: async ()=>(await (parcelRequire("kP5tp"))).QRCodeComponent,
    loading: $2fa2236fe735b9be$var$LoadingSpinner
});



var $euF5O = parcelRequire("euF5O");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $cMvQV = parcelRequire("cMvQV");


var $Qlykt = parcelRequire("Qlykt");


var $ep3mz = parcelRequire("ep3mz");


var $kDhla = parcelRequire("kDhla");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");








var $l1b8J = parcelRequire("l1b8J");

const $a7ed65c805684c1a$export$5306b0eb80cf6407 = ()=>{
    const { exitPresenterMode: exitPresenterMode } = (0, $l1b8J.usePresenterModeContext)();
    (0, $cozmU.useEffect)(()=>{
        // Event handler for when entering/exiting fullscreen mode
        const handleFullscreenChange = ()=>{
            /**
       * This handles the case where the user has pressed Esc instead of using
       * the "Exit" button to close presenter mode. In this case, the browser
       * will be forced out of fullscreen mode, but presenter mode will still
       * technically be active, so we need to listen for the event to make
       * sure we exit presenter mode.
       */ if (!(0, $d3MrN.default).fullscreenElement) exitPresenterMode();
        };
        (0, $d3MrN.default).addEventListener('fullscreenchange', handleFullscreenChange, false);
        return ()=>{
            /**
       * This handles the common case where the user clicks the "Exit" button to close
       * presenter mode, which will cause this callback to run.
       */ if ((0, $d3MrN.default).fullscreenElement) (0, $d3MrN.default).exitFullscreen();
            (0, $d3MrN.default).removeEventListener('fullscreenchange', handleFullscreenChange, false);
        };
    }, [
        exitPresenterMode
    ]);
};





const $e231207f12babf5b$export$bd4ec12442706c3d = ()=>{
    (0, $cozmU.useLayoutEffect)(()=>{
        const originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.body.style.overflow = originalStyle;
        };
    }, []);
};





const $731701c7a4a3e42e$export$3fe03aa4ff5dc935 = (setFlagsVisibility)=>{
    (0, $cozmU.useEffect)(()=>{
        setFlagsVisibility(false);
        return ()=>{
            setFlagsVisibility(true);
        };
    }, [
        setFlagsVisibility
    ]);
};



var $2jkzM = parcelRequire("2jkzM");


var $ibtF1 = parcelRequire("ibtF1");





var $FKQbh = parcelRequire("FKQbh");


var $24dy7 = parcelRequire("24dy7");

const $dfd48e08cc962979$export$518ba8e0e60f145f = ({ title: title })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        appearance: "error",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            spacing: "spacious",
            label: "Error"
        }),
        id: "error",
        key: "error",
        title: title
    });
};



var $gnyTR = parcelRequire("gnyTR");





var $fDEVM = parcelRequire("fDEVM");

const $bdd13d294a89f9eb$var$i18n = (0, $kSwu1.defineMessages)({
    genericErrorMessage: {
        id: "presentation-mode.portal.generic.error.message",
        defaultMessage: "Something\u2019s not right. Refresh and try again."
    }
});
const $bdd13d294a89f9eb$var$presenterModeContainerStyle = null;
const $bdd13d294a89f9eb$var$spacerStyle = null; /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
const $bdd13d294a89f9eb$var$titleFixedSpacingStyle = null; /* eslint-enable @atlaskit/design-system/use-tokens-typography */ 
const $bdd13d294a89f9eb$export$fa29436318a8d949 = 'presenter-mode-zoom-container';
const $bdd13d294a89f9eb$export$e1872a7bb3bd287c = 'presenter-mode-container';
const $bdd13d294a89f9eb$export$158030c0e49f9498 = 'presenter-mode-portal-container';
const $bdd13d294a89f9eb$export$750df9d29fdbd29f = 'presenter-mode-title-text';
const $bdd13d294a89f9eb$export$9439b54f8681bb48 = 'presenter-mode-content-container';
const $bdd13d294a89f9eb$export$4d12947f8edb059f = 'presenter-mode-content-container-bottom-spacer';
(0, $cMvQV.setUserAgent)();
const $bdd13d294a89f9eb$var$legacyMacroRendererContextValue = {
    shouldRefetchMacroQuery: true
};
const $bdd13d294a89f9eb$var$presenterModeStickyHeaders = {
    offsetTop: 0
};
const $bdd13d294a89f9eb$var$PresenterModePortalContentFragment = (0, $78439205b7877f59$export$2e2bcd8739ae039);
const $bdd13d294a89f9eb$var$PresenterModePortalPresenterModeContentTitleQuery = (0, $0cb2cdb46393f11b$export$2e2bcd8739ae039);
const $bdd13d294a89f9eb$var$PresenterModePortalPresenterModeCoverPictureQuery = (0, $43087a03fe0f39ae$export$2e2bcd8739ae039);
const $bdd13d294a89f9eb$var$PresenterModePortalRender = ({ contentId: contentId, spaceKey: spaceKey, isCustomCursorActive: isCustomCursorActive, contentRendered: contentRendered, onSwitchCursor: onSwitchCursor, loading: loading, coverPictureProperty: coverPictureProperty, error: error, title: title, emojiTitle: emojiTitle, contentData: contentData, editorContent: editorContent, onRendered: onRendered, isTitleCenterAligned: isTitleCenterAligned, viewportWidth: viewportWidth, intl: intl })=>{
    const hasCoverPicture = !!coverPictureProperty;
    const hasEmoji = !!emojiTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: 519
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1enXm.default), {
        autoFocus: false,
        returnFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.PresenterModePortalContainer), {
        id: $bdd13d294a89f9eb$export$158030c0e49f9498,
        isCustomCursorActive: isCustomCursorActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2jkzM.HeaderPresenterMode), {
        contentRendered: contentRendered,
        onSwitchCursorClick: onSwitchCursor,
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: $bdd13d294a89f9eb$export$e1872a7bb3bd287c,
        className: (0, $hekY6.default)([
            "_39xV02N91d"
        ])
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.LoadingContainer), {
        "data-testid": "presenter-mode-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large",
        interactionName: "presenter-mode-portal"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ibtF1.HeaderImage), {
        contentId: contentId,
        coverPictureProperty: coverPictureProperty
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.PresenterModeZoomContainer), {
        "data-testid": "presenter-mode-zoom-container",
        id: $bdd13d294a89f9eb$export$fa29436318a8d949,
        isFirefox: (0, $cMvQV.isFirefox)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.FlagsContainer), null, Boolean(error) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dfd48e08cc962979$export$518ba8e0e60f145f), {
        title: intl.formatMessage($bdd13d294a89f9eb$var$i18n.genericErrorMessage)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.TitleContainer), {
        id: $bdd13d294a89f9eb$export$750df9d29fdbd29f,
        "data-testid": "presenter-mode-title-container",
        hasCoverPicture: hasCoverPicture,
        isTitleCenterAligned: isTitleCenterAligned,
        hasEmoji: hasEmoji,
        width: viewportWidth
    }, emojiTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.EmojiWrapper), {
        hasCoverPicture: hasCoverPicture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emojiTitle,
        height: hasCoverPicture ? (0, $Qlykt.EMOJI_SIZE_LARGE) : (0, $Qlykt.EMOJI_SIZE_MEDIUM),
        hasCoverPicture: hasCoverPicture,
        isPageTitleComponent: true,
        context: "presenterMode",
        showTooltip: true,
        renderResourcedEmoji: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.TitleTextWrapper), {
        "data-testId": "titleTextWrapper",
        shouldAddLeftPadding: hasEmoji && !isTitleCenterAligned && !hasCoverPicture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("h1", {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _1kk5TkN779 _1UtDYzy7kJ _3W2Oc8wPeg _3zvHkHwPeg _4kiQYAS40j _0Of8r2gVvo _3iDTPbvLZJ _4ya3eECBl1 _26BoRwGt0E _2UheSnpJKa _1cTrnnmdCj _3VvjmbhzUg _2AcsaDpJKa"
        ])
    }, title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $euF5O.LegacyMacroRendererContext).Provider, {
        value: $bdd13d294a89f9eb$var$legacyMacroRendererContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8Lxy.PageContentRenderer), {
        contentId: contentId,
        document: editorContent,
        data: contentData,
        onRendered: onRendered,
        hasInlineComments: false,
        appearance: "full-page",
        stickyHeaders: $bdd13d294a89f9eb$var$presenterModeStickyHeaders,
        spaceKey: spaceKey,
        isPresentational: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: $bdd13d294a89f9eb$export$4d12947f8edb059f,
        className: (0, $hekY6.default)([
            "_0jFU0VHMkp"
        ])
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2fa2236fe735b9be$export$c545dc5a218e1111), {
        contentId: contentId,
        spaceKey: spaceKey
    })))));
};
const $bdd13d294a89f9eb$var$PresenterModePortalFragmentData = ({ contentNode: contentNode, contentLoading: contentLoading, contentUnifiedError: contentUnifiedError, ...props })=>{
    const fragmentData = (0, $6SsN4.useFragment)($bdd13d294a89f9eb$var$PresenterModePortalContentFragment, contentNode);
    const emojiTitle = (0, $8rneB.getEmojiFromPublishedPageProperties)(fragmentData);
    const coverPictureProperty = fragmentData?.properties?.nodes?.find((node)=>node?.key === 'cover-picture-id-published');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bdd13d294a89f9eb$var$PresenterModePortalRender, {
        ...props,
        loading: contentLoading,
        coverPictureProperty: coverPictureProperty,
        error: contentUnifiedError,
        title: fragmentData?.title ?? '',
        emojiTitle: emojiTitle
    });
};
const $bdd13d294a89f9eb$var$PresenterModePortalQueryData = ({ contentId: contentId, contentLoading: contentLoading, contentUnifiedError: contentUnifiedError, ...props })=>{
    const { data: titleData, loading: titleLoading, error: contentTitleError } = (0, $jMyy4.useQueryInterop)($bdd13d294a89f9eb$var$PresenterModePortalPresenterModeContentTitleQuery, {
        fetchPolicy: 'cache-first',
        variables: {
            contentId: contentId
        },
        __callerPackage__: "presentation-mode"
    });
    const { data: coverPictureQueryData, loading: coverPictureLoading, error: presenterModeCoverPictureError } = (0, $jMyy4.useQueryInterop)($bdd13d294a89f9eb$var$PresenterModePortalPresenterModeCoverPictureQuery, {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        variables: {
            contentId: contentId,
            status: [
                'current'
            ]
        },
        __callerPackage__: "presentation-mode"
    });
    const coverPictureProperty = coverPictureQueryData?.content?.nodes?.[0]?.properties?.nodes?.[0] ?? undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bdd13d294a89f9eb$var$PresenterModePortalRender, {
        ...props,
        contentId: contentId,
        loading: contentLoading || titleLoading || coverPictureLoading,
        coverPictureProperty: coverPictureProperty,
        error: contentTitleError || contentUnifiedError || presenterModeCoverPictureError,
        title: titleData?.content?.nodes?.[0]?.title ?? '',
        emojiTitle: (0, $8rneB.getPublishedEmojiId)(titleData)
    });
}; /**
    * This component encapsulates the actual presenter mode experience. It's responsible
    * for rendering the nav bar and the content itself, which it gets via GraphQL.
    * Everything is placed within a Portal component which is rendered on top of the page.
    */ 
const $bdd13d294a89f9eb$export$c815374aa38c89e7 = ({ contentId: contentId, spaceKey: spaceKey, setFlagsVisibility: setFlagsVisibility })=>{
    const [isCustomCursorActive, setIsCustomCursorActive] = (0, $cozmU.useState)(true);
    const [contentRendered, setContentRendered] = (0, $cozmU.useState)(false);
    const [editorContent, setEditorContent] = (0, $cozmU.useState)();
    const { isBrowserFullscreen: isBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    const [{ fullPageEditorPresetAPI: editorApi }] = (0, $kDhla.useFullPageEditorApi)();
    const intl = (0, $kSwu1.useIntl)();
    const handleSwitchCursor = (newValue)=>setIsCustomCursorActive(newValue); // Prevent scrolling of content underneath the portal
    (0, $e231207f12babf5b$export$bd4ec12442706c3d)(); // Handles entering/exiting fullscreen mode
    (0, $a7ed65c805684c1a$export$5306b0eb80cf6407)();
    (0, $cozmU.useEffect)(()=>{
        editorApi?.core.actions.requestDocument((doc)=>{
            setEditorContent(doc);
        });
    }, [
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isBrowserFullscreen) (0, $d3MrN.default).exitFullscreen();
    }, [
        isBrowserFullscreen
    ]); // Handles hiding flags while in Presenter Mode
    (0, $731701c7a4a3e42e$export$3fe03aa4ff5dc935)(setFlagsVisibility);
    const [contentType] = (0, $ep3mz.useContentType)();
    const isBlogpost = contentType === 'blogpost';
    const skipContentUnifiedQuery = !contentId || !spaceKey; // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const pageContentUnifiedResult = (0, $jMyy4.useQueryInterop)((0, $jgc4t.default), {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: skipContentUnifiedQuery || isBlogpost,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: null
        },
        __callerPackage__: "presentation-mode"
    });
    const blogContentUnifiedResult = (0, $jMyy4.useQueryInterop)((0, $f9opb.default), {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: skipContentUnifiedQuery || !isBlogpost,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: null
        },
        __callerPackage__: "presentation-mode"
    });
    const { data: contentData, loading: contentLoading, error: contentUnifiedError } = isBlogpost ? blogContentUnifiedResult : pageContentUnifiedResult;
    const contentNode = contentData?.content?.nodes?.[0];
    const handleOnRenderedEvent = ()=>setContentRendered(true);
    const isTitleCenterAligned = (0, $fDEVM.useIsTitleCenterAligned)(contentId);
    const [viewportWidth, setViewportWidth] = (0, $cozmU.useState)(window.innerWidth);
    (0, $cozmU.useEffect)(()=>{
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    const sharedProps = {
        contentId: contentId,
        spaceKey: spaceKey,
        isCustomCursorActive: isCustomCursorActive,
        contentRendered: contentRendered,
        onSwitchCursor: handleSwitchCursor,
        contentData: contentData,
        editorContent: editorContent,
        onRendered: handleOnRenderedEvent,
        isTitleCenterAligned: isTitleCenterAligned,
        viewportWidth: viewportWidth,
        intl: intl
    };
    if (!(0, $1xpoY.default).isKillSwitchOn('confluence_frontend_view_page_relay_fragment_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bdd13d294a89f9eb$var$PresenterModePortalFragmentData, {
        ...sharedProps,
        contentNode: contentNode,
        contentLoading: contentLoading,
        contentUnifiedError: contentUnifiedError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bdd13d294a89f9eb$var$PresenterModePortalQueryData, {
        ...sharedProps,
        contentLoading: contentLoading,
        contentUnifiedError: contentUnifiedError
    });
};
module.exports["PresenterModeZoomContainerId"] = $bdd13d294a89f9eb$export$fa29436318a8d949;
module.exports["PresenterModeContainerId"] = $bdd13d294a89f9eb$export$e1872a7bb3bd287c;
module.exports["PresenterModePortalContainerId"] = $bdd13d294a89f9eb$export$158030c0e49f9498;
module.exports["PresenterModePageTitleId"] = $bdd13d294a89f9eb$export$750df9d29fdbd29f;
module.exports["PresenterModeBottomSpacerId"] = $bdd13d294a89f9eb$export$4d12947f8edb059f;
module.exports["PresenterModePortal"] = $bdd13d294a89f9eb$export$c815374aa38c89e7;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    // For signed-in users, allowAnonymousAccess does not change the provider config. Sharing the
    // resource lets uploads propagate immediately between editor, title, and reaction pickers.
    const allowAnonymousAccessCacheKey = userId ? false : allowAnonymousAccess;
    return `${cloudId}_${userId}_${allowAnonymousAccessCacheKey}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $4xiow = parcelRequire("4xiow");


var $drRzc = parcelRequire("drRzc");


var $anBbz = parcelRequire("anBbz");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            if ((0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                // Skip SSR for nodes without an Id
                if (!node.attrs.id) return undefined;
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    id: node.attrs.id,
                    shortName: node.attrs.shortName,
                    fallback: node.attrs.text,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    },
                    searchable: true,
                    type: '',
                    category: ''
                };
            }
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // For STANDARD emojis, return a UnicodeRepresentation so they are rendered
            // as native text characters rather than images (twemoji removal).
            if (node.attrs.id && result && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    ...result,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    }
                };
            }
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.updateCache(ssrData, {
            strategy: 'replace',
            source: 'ssr'
        });
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.updateCache({
                    [dataKey]: data
                }, {
                    strategy: 'merge',
                    source: 'network'
                });
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("jy98N"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_2uo31fGsB2 _0bjKvDzXzM _2XghbEPgdg _3iDTPbvbI6 _0Of8r2Pgdg"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("jy98N", function(module, exports) {

let $e3b8487fd5fe4ddd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e3b8487fd5fe4ddd$var$load("2hPbk"),
    $e3b8487fd5fe4ddd$var$load("icYyL"),
    $e3b8487fd5fe4ddd$var$load("1audf"),
    $e3b8487fd5fe4ddd$var$load("bpBPu"),
    $e3b8487fd5fe4ddd$var$load("gFeoL"),
    $e3b8487fd5fe4ddd$var$load("6wr18"),
    $e3b8487fd5fe4ddd$var$load("iNbHV"),
    $e3b8487fd5fe4ddd$var$load("ffEVr"),
    $e3b8487fd5fe4ddd$var$load("4Ldt2"),
    $e3b8487fd5fe4ddd$var$load("5gsbh"),
    $e3b8487fd5fe4ddd$var$load("2dYOx"),
    $e3b8487fd5fe4ddd$var$load("5RJ9W"),
    $e3b8487fd5fe4ddd$var$load("8OeKT"),
    $e3b8487fd5fe4ddd$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("kP5tp", function(module, exports) {

let $f28cd0f37a03f89e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f28cd0f37a03f89e$var$load("6wr18"),
    $f28cd0f37a03f89e$var$load("ffEVr"),
    $f28cd0f37a03f89e$var$load("2nHxT")
]).then(()=>parcelRequire('5RnXN'));

});

parcelRegister("euF5O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $914eacf4cf3bd652$export$26c05f52dcf7c5f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    shouldRefetchMacroQuery: false
});
module.exports["LegacyMacroRendererContext"] = $914eacf4cf3bd652$export$26c05f52dcf7c5f2;

});

parcelRegister("Qlykt", function(module, exports) {
const $f866e8db934ec558$export$d7240ab6bd9deaf0 = 40;
const $f866e8db934ec558$export$7d383c70a74caba8 = 80;
module.exports["EMOJI_SIZE_MEDIUM"] = $f866e8db934ec558$export$d7240ab6bd9deaf0;
module.exports["EMOJI_SIZE_LARGE"] = $f866e8db934ec558$export$7d383c70a74caba8;

});

parcelRegister("kDhla", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $8s9DV.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $kBr4q.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $kBr4q.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $kBr4q.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("2jkzM", function(module, exports) {
/* HeaderPresenterMode.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $9DHhW = parcelRequire("9DHhW");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $7QM6o = parcelRequire("7QM6o");


var $3IVqo = parcelRequire("3IVqo");


var $gnyTR = parcelRequire("gnyTR");

/* LazyButtons.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $lfoFx = parcelRequire("lfoFx");


var $jmjWc = parcelRequire("jmjWc");

const $cb3e4c1f9ef026ad$var$spinnerContainerStyles = null;
const $cb3e4c1f9ef026ad$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0jFU0VUofl _39xV02Uofl _0adFHs8HPE"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "presentation-mode-lazy-buttons"
    }));

const $cb3e4c1f9ef026ad$export$490f62136438ac6e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9F1oH",
    name: "LazyNavigation",
    loader: async ()=>(await (parcelRequire("6cTcM"))).NavigationPresenterMode,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb3e4c1f9ef026ad$var$LoadingSpinner, null)
});

const $cb3e4c1f9ef026ad$export$37c96b963636f7cc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "60c-p",
    name: "LazySettingsMenu",
    loader: async ()=>(await (parcelRequire("lUC7J"))).SettingsMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb3e4c1f9ef026ad$var$LoadingSpinner, null)
});



var $l1b8J = parcelRequire("l1b8J");

const $66cd5922db697139$export$ef625543408b2447 = 'presenter-mode-control-panel';
const $66cd5922db697139$var$headerContainerStyles = null;
const $66cd5922db697139$var$verticalDividerStyles = null;
const $66cd5922db697139$var$rightControlPanelStyles = null;
const $66cd5922db697139$var$i18n = (0, $kSwu1.defineMessages)({
    exit: {
        id: "presentation-mode.header.exit",
        defaultMessage: "Exit"
    }
});
const $66cd5922db697139$export$c7c42ad700a3285 = ({ onSwitchCursorClick: onSwitchCursorClick, contentRendered: contentRendered, spaceKey: spaceKey, contentId: contentId })=>{
    const { exitPresenterMode: exitPresenterMode, isBrowserFullscreen: isBrowserFullscreen, setIsBrowserFullscreen: setIsBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const [showLazyButtons, setShowLazyButtons] = (0, $cozmU.useState)(false);
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    (0, $cozmU.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setShowLazyButtons(true);
        }, 0);
        return ()=>{
            clearTimeout(timeout);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewPresentScreen',
                attributes: {
                    objectId: contentId,
                    containerId: spaceId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        spaceId
    ]);
    const exit = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'present',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'close',
                objectId: contentId,
                containerId: spaceId
            }
        }).fire();
        exitPresenterMode();
    }, [
        createAnalyticsEvent,
        exitPresenterMode,
        contentId,
        spaceId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3IVqo.ControlPanelContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "presentation-mode-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: $66cd5922db697139$export$ef625543408b2447,
        className: (0, $hekY6.default)([
            "_4FKVYE8HPE _0bjKvDKxmn _0hPCNLDIqT _0KLXruoI2d _1mT5xdy1CL _2IhTonNHnM _4ApkO2NHnM _3iDTPbQ4SZ _42Yu6BHOnL _2OUyjtGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2XsHFMIZbP _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb3e4c1f9ef026ad$export$490f62136438ac6e), {
        contentRendered: contentRendered,
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3JzbaeOeNX _0jFU0VoWWg _39xV02dnbC"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb3e4c1f9ef026ad$export$37c96b963636f7cc), {
        onSwitchCursorClick: onSwitchCursorClick,
        contentId: contentId,
        spaceKey: spaceKey
    }), contentRendered && showLazyButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.ButtonContainer), {
        id: "presenter-mode-exit-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "presentation-mode-button-close",
        onClick: isBrowserFullscreen ? ()=>setIsBrowserFullscreen(false) : exit
    }, intl.formatMessage($66cd5922db697139$var$i18n.exit))))))));
};
module.exports["HeaderControlPanel"] = $66cd5922db697139$export$ef625543408b2447;
module.exports["HeaderPresenterMode"] = $66cd5922db697139$export$c7c42ad700a3285;

});

parcelRegister("3IVqo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $969cdac05668aa2c$var$ControlPanelContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    isSettingsOpen: false,
    setIsSettingsOpen: ()=>{
    // Intentional no-op
    },
    isNavigationMenuOpen: false,
    setIsNavigationMenuOpen: ()=>{
    // Intentional no-op
    },
    width: '1'
});
const $969cdac05668aa2c$export$a5457ef551a7a8bf = ({ children: children })=>{
    const [isSettingsOpen, setIsSettingsOpen] = (0, $cozmU.useState)(false);
    const [isNavigationMenuOpen, setIsNavigationMenuOpen] = (0, $cozmU.useState)(false);
    const [width, setWidth] = (0, $cozmU.useState)('1');
    const headerWidth = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById('presenter-mode-control-panel')?.getBoundingClientRect().width || 242;
    (0, $cozmU.useEffect)(()=>{
        setWidth(headerWidth.toString());
    }, [
        headerWidth
    ]);
    const data = (0, $cozmU.useMemo)(()=>({
            isSettingsOpen: isSettingsOpen,
            setIsSettingsOpen: setIsSettingsOpen,
            isNavigationMenuOpen: isNavigationMenuOpen,
            setIsNavigationMenuOpen: setIsNavigationMenuOpen,
            width: width
        }), [
        isSettingsOpen,
        setIsSettingsOpen,
        isNavigationMenuOpen,
        setIsNavigationMenuOpen,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($969cdac05668aa2c$var$ControlPanelContext.Provider, {
        value: data
    }, children);
};
const $969cdac05668aa2c$export$7a069434e96a0028 = ()=>{
    return (0, $cozmU.useContext)($969cdac05668aa2c$var$ControlPanelContext);
};
module.exports["ControlPanelContextProvider"] = $969cdac05668aa2c$export$a5457ef551a7a8bf;
module.exports["useControlPanelContext"] = $969cdac05668aa2c$export$7a069434e96a0028;

});

parcelRegister("gnyTR", function(module, exports) {
/* presenterModeStyles.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $Qlykt = parcelRequire("Qlykt");

var $096b119344840642$exports = {};
$096b119344840642$exports = new URL("customCursor.8a87402c.svg", import.meta.url).toString();


const $72178c9eda154f79$var$screenSizeXS = 1080;
const $72178c9eda154f79$var$screenSizeS = 1280;
const $72178c9eda154f79$var$screenSizeM = 1536;
const $72178c9eda154f79$var$screenSizeL = 2560;
const $72178c9eda154f79$var$screenSizeHeaderImageBreakpoint = 1792;
const $72178c9eda154f79$var$CALCULATE_SCALED_COVER_IMAGE_HEIGHT_PRESENTER_MODE = 'min(max(calc(100vw * (7 / 38)), 140px), 750px)';
const $72178c9eda154f79$export$5aeddb36a71179f1 = -122;
const $72178c9eda154f79$export$18d6dec26df5efab = -104;
const $72178c9eda154f79$export$5cbab9ac5bb5eb6 = -95;
const $72178c9eda154f79$export$9efff5a152b2c8b9 = -82;
const $72178c9eda154f79$var$zoomLevelXSToM = 1.3;
const $72178c9eda154f79$var$zoomLevelL = 2;
const $72178c9eda154f79$var$cursorImage = `url(${(0, (/*@__PURE__*/$parcel$interopDefault($096b119344840642$exports)))}), auto`;
const $72178c9eda154f79$var$headerImageMediaQuery = {
    [`@media only screen and (min-width: ${$72178c9eda154f79$var$screenSizeHeaderImageBreakpoint}px)`]: {
        height: '360px'
    },
    [`@media only screen and (min-width: ${$72178c9eda154f79$var$screenSizeM}px) and (max-width: ${$72178c9eda154f79$var$screenSizeHeaderImageBreakpoint}px)`]: {
        height: '240px'
    },
    [`@media only screen and (max-width: ${$72178c9eda154f79$var$screenSizeM}px)`]: {
        height: '240px'
    }
};
const $72178c9eda154f79$export$ec38912285043019 = '1.5';
const $72178c9eda154f79$export$21d0e1ba36d5f647 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCustomCursorActive: isCustomCursorActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1db81y0": (0, $9aYkv.default)($72178c9eda154f79$var$cursorImage)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02qUim _0jFU0VWP8C _0KLXrulfZc _1mT5xdy1CL _2IhTondnbC _3OE6xYdnbC _2WAcuGLTLW _4bt5LAnQyn _3iDTPbQ4SZ _37wbyuDIqT _1Iq3WEYbGa _15QM2vOiJt _3fwf53OiJt _07PAZcU77s _3kZsVwOiJt _1pEPU0DIqT _2t1ILkVa5s _0QlLlGDIqT _2zPjG3YbGa",
            __cmplp.isCustomCursorActive ? "_0wOv4Q5MK9" : "_0wOv4QIZbP",
            __cmplp.isCustomCursorActive ? "_0acWuSCzj6" : "_0acWuSU77s",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$4b720caa3a1b5952 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fDMqu _0jFU0VlpyH _39xV02qUim _1DCdHiyFLW _27VrYpPgdg _0Ts0IxZqHV _2rWOAdZqHV _36tfrOwBC3 _4tBjibGVdc _21pNNZGVdc _3CHuwjN91d _4wCECZN91d _0Hb43qZqHV _2fs9BZN91d _0MdbOFPgdg _1z7xmEwBC3 _3oPxm8GVdc _3NXnmVGVdc _2uOYsGGVdc _2Wu2Z3wBC3 _3Aden1GVdc",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$141080fc4b582742 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1DCdHiVa5s _0jFU0Vb1xp",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$422f3370501bb5d5 = (scale, isFirefox)=>{
    return isFirefox ? `transform: scale(${scale})` : `zoom: ${scale};`;
};
const $72178c9eda154f79$export$354b8b07cc867365 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirefox: isFirefox, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _0yKXXaBwqQ _2ZftLr8yGE _03Q2gnsfvo _4Gnv1KL3tl _40kS8HAthV",
            __cmplp.isFirefox ? "_17edDNMgaz" : undefined,
            __cmplp.isFirefox ? undefined : "_4evpNUiZR3",
            __cmplp.isFirefox ? "_1hWSvYPrS9" : undefined,
            __cmplp.isFirefox ? undefined : "_0GAmc0dIGx",
            __cmplp.isFirefox ? "_0FtVHtVzjv" : undefined,
            __cmplp.isFirefox ? undefined : "_4kmPg3af8D",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$5e3f251c730829 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _0jFU0VWP8C",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$35e09ba17cc51c69 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, hasEmoji: hasEmoji, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XghbEl32T _3iDTPbQ4SZ _24h04i2Njc _4kiQYA7GLB _39xV02N91d _1EqgXl8yGE _3W2Oc8wPeg _1T2N03wPeg",
            __cmplp.isTitleCenterAligned ? "_37wbyuDIqT" : "_37wbyuzUZr",
            __cmplp.isTitleCenterAligned || __cmplp.hasCoverPicture ? "_0aFT5vbt8w" : "_0aFT5v1qpb",
            __cmplp.isTitleCenterAligned ? "_0hPCNLDIqT" : "_0hPCNLQame",
            __cmplp.hasCoverPicture || __cmplp.isTitleCenterAligned && __cmplp.hasEmoji ? "_2mHwu85zaO" : "_2mHwu8yL8i",
            __cmplp.hasCoverPicture && __cmplp.hasEmoji ? "_313842RiSR" : "_313842dnbC",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$f39f7ca4ec945bd5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldAddLeftPadding: shouldAddLeftPadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.shouldAddLeftPadding ? "_2Zuz6Q8HPE" : "_2Zuz6QZqHV",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$var$emojiCoverPictureMaxWidth = (hasCoverPicture)=>hasCoverPicture ? `${0, $Qlykt.EMOJI_SIZE_LARGE}px` : `${0, $Qlykt.EMOJI_SIZE_MEDIUM}px`;
const $72178c9eda154f79$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_mn762q": (0, $9aYkv.default)($72178c9eda154f79$var$emojiCoverPictureMaxWidth(__cmplp.hasCoverPicture))
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _1EqgXlOSVc _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$1b225d69cabf8532 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4rYULUVpNL _3ODULk9XL4 _4nvRjBpNyl",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XsHFM2ADO _3iDTPbvbI6",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$a87575d1597be323 = (width)=>{
    if (!width || width < $72178c9eda154f79$var$screenSizeXS) return $72178c9eda154f79$export$5aeddb36a71179f1;
    else if (width < $72178c9eda154f79$var$screenSizeM) return $72178c9eda154f79$export$18d6dec26df5efab;
    else if (width < $72178c9eda154f79$var$screenSizeL) return $72178c9eda154f79$export$5cbab9ac5bb5eb6;
    else return $72178c9eda154f79$export$9efff5a152b2c8b9;
};
module.exports["mToLScreenZoomLevel"] = $72178c9eda154f79$export$ec38912285043019;
module.exports["PresenterModePortalContainer"] = $72178c9eda154f79$export$21d0e1ba36d5f647;
module.exports["HeaderImageContainer"] = $72178c9eda154f79$export$4b720caa3a1b5952;
module.exports["NoHeaderImageSpacer"] = $72178c9eda154f79$export$141080fc4b582742;
module.exports["PresenterModeZoomContainer"] = $72178c9eda154f79$export$354b8b07cc867365;
module.exports["LoadingContainer"] = $72178c9eda154f79$export$5e3f251c730829;
module.exports["SpinnerContainer"] = $72178c9eda154f79$export$a5e06607a5ac6158;
module.exports["TitleContainer"] = $72178c9eda154f79$export$35e09ba17cc51c69;
module.exports["TitleTextWrapper"] = $72178c9eda154f79$export$f39f7ca4ec945bd5;
module.exports["EmojiWrapper"] = $72178c9eda154f79$export$e31a6cc0a4c97f0e;
module.exports["FlagsContainer"] = $72178c9eda154f79$export$1b225d69cabf8532;
module.exports["ButtonContainer"] = $72178c9eda154f79$export$eddf54ea3db8d0f0;

});

parcelRegister("6cTcM", function(module, exports) {

let $484eafa2caaa60a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $484eafa2caaa60a6$var$load("ea3NB"),
    $484eafa2caaa60a6$var$load("6wr18"),
    $484eafa2caaa60a6$var$load("7EorR"),
    $484eafa2caaa60a6$var$load("aLbuU"),
    $484eafa2caaa60a6$var$load("ffEVr"),
    $484eafa2caaa60a6$var$load("hhss7"),
    $484eafa2caaa60a6$var$load("9IaUU")
]).then(()=>parcelRequire('lQ3Oi'));

});

parcelRegister("lUC7J", function(module, exports) {

let $ff3c668328ed66d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ff3c668328ed66d7$var$load("6wr18"),
    $ff3c668328ed66d7$var$load("ffEVr"),
    $ff3c668328ed66d7$var$load("Wowvf"),
    $ff3c668328ed66d7$var$load("hhss7"),
    $ff3c668328ed66d7$var$load("62AD8")
]).then(()=>parcelRequire('2JGhm'));

});

parcelRegister("ibtF1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3oWMY = parcelRequire("3oWMY");


var $3WPGR = parcelRequire("3WPGR");


var $1d2ww = parcelRequire("1d2ww");


var $gnyTR = parcelRequire("gnyTR");


var $fDEVM = parcelRequire("fDEVM");

const $647837bde418af85$export$82c94077b89191c5 = 'presenter-mode-header-image-container';
const $647837bde418af85$export$7b5e76b410389064 = ({ contentId: contentId, coverPictureProperty: coverPictureProperty })=>{
    const [coverPictureData, setCoverPictureData] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (!coverPictureProperty) return;
        const publishedId = (0, $3WPGR.propertyToId)(coverPictureProperty);
        if (!publishedId) return;
        const coverPic = {
            draft: null,
            published: {
                value: {
                    id: (0, $fDEVM.createHigherResImgSrc)(publishedId?.value?.id),
                    position: publishedId?.value?.position || 0
                },
                version: publishedId?.version
            }
        };
        setCoverPictureData(coverPic);
    }, [
        coverPictureProperty
    ]);
    if (!coverPictureData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.NoHeaderImageSpacer), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.HeaderImageContainer), {
        id: $647837bde418af85$export$82c94077b89191c5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3oWMY.RendererPageCoverPicture), {
        contentId: contentId,
        isPagePreview: false,
        coverPicture: coverPictureData,
        contentAppearance: {
            draft: '',
            published: (0, $1d2ww.ContentAppearanceType).FULL_WIDTH
        },
        isSpaceOverview: false,
        isPresenterMode: true
    }));
};
module.exports["HeaderImageContainerId"] = $647837bde418af85$export$82c94077b89191c5;
module.exports["HeaderImage"] = $647837bde418af85$export$7b5e76b410389064;

});

parcelRegister("3oWMY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $goxV5 = parcelRequire("goxV5");


const $aac74fc16bd2f0e9$export$60620c3d63f5f30 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tETtx",
    name: "RendererPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("gAVpY"))).RendererPageCoverPicture;
    },
    loading: (0, $goxV5.RendererPageCoverPicturePlaceholder)
});
module.exports["RendererPageCoverPicture"] = $aac74fc16bd2f0e9$export$60620c3d63f5f30;

});

parcelRegister("goxV5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $jVylI = parcelRequire("jVylI");


var $75Ax4 = parcelRequire("75Ax4");

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/use-tokens-space, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766 */ const $be005db184746995$var$Placeholder = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $9aYkv.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1DCdHiPgdg _0KLXruDMqu",
                __cmplp.isFixedWidthImageOption ? "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _313842LYhK _39xV02OAqP" : "_313842LYhK _39xV02rFfx _2XsHFM5ksT",
                __cmplp.smartSpaceOverviewHeight ? "_0jFU0Vm31q" : __cmplp.isFixedWidthImageOption ? "_0jFU0V6Tex" : "_0jFU0VurUm",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $be005db184746995$export$e9417b149b0db09d = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { coverPicture: coverPicture, isPagePreview: isPagePreview, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, coverPictureWidthOverride: coverPictureWidthOverride, isSmartSpaceOverview: isSmartSpaceOverview } = t0;
    const hasCoverPicture = isPagePreview ? !!coverPicture?.draft?.value?.id : !!coverPicture?.published?.value?.id;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const isFixedWidthImageOption = coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const smartSpaceOverviewHeight = isSmartSpaceOverview ? (0, $75Ax4.SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH) : undefined;
    let t1;
    if ($[0] !== appearance || $[1] !== hasCoverPicture || $[2] !== hasEmoji || $[3] !== isFixedWidthImageOption || $[4] !== isPagePreview || $[5] !== isSpaceOverview || $[6] !== smartSpaceOverviewHeight) {
        t1 = hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be005db184746995$var$Placeholder, {
            contentAppearance: appearance,
            isPagePreview: isPagePreview,
            isSpaceOverview: isSpaceOverview,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            hasEmoji: hasEmoji,
            isFixedWidthImageOption: isFixedWidthImageOption
        })) : null;
        $[0] = appearance;
        $[1] = hasCoverPicture;
        $[2] = hasEmoji;
        $[3] = isFixedWidthImageOption;
        $[4] = isPagePreview;
        $[5] = isSpaceOverview;
        $[6] = smartSpaceOverviewHeight;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
module.exports["RendererPageCoverPicturePlaceholder"] = $be005db184746995$export$e9417b149b0db09d;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("75Ax4", function(module, exports) {
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$a9612492250fd8ea = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$b143b999ce4b353a = `round(down, calc(100cqw / (${$4cdfc0aeee394c11$export$e63c70235aab4f60})), 1px)`;
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;
const $4cdfc0aeee394c11$export$a682f4bbb3650e11 = 200;
module.exports["DEFAULT_POSITION_VALUE"] = $4cdfc0aeee394c11$export$5a7e63ae23cefcb;
module.exports["REFERRAL_LINK"] = $4cdfc0aeee394c11$export$535fddacdd1506a3;
module.exports["MIN_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$41f496cb75ebdbf4;
module.exports["MAX_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$e1a10bbd512cde25;
module.exports["COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO"] = $4cdfc0aeee394c11$export$e63c70235aab4f60;
module.exports["CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE"] = $4cdfc0aeee394c11$export$b143b999ce4b353a;
module.exports["COVER_IMAGE_FIXED_WIDTH"] = $4cdfc0aeee394c11$export$f94fb8385ddeea1f;
module.exports["COVER_IMAGE_FIXED_HEIGHT"] = $4cdfc0aeee394c11$export$f60e801aad1e2af5;
module.exports["SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH"] = $4cdfc0aeee394c11$export$a682f4bbb3650e11;

});

parcelRegister("gAVpY", function(module, exports) {

let $c14c8c21b007c47f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c14c8c21b007c47f$var$load("aqMLH"),
    $c14c8c21b007c47f$var$load("ctdyb"),
    $c14c8c21b007c47f$var$load("f6ZVy"),
    $c14c8c21b007c47f$var$load("2hPbk"),
    $c14c8c21b007c47f$var$load("icYyL"),
    $c14c8c21b007c47f$var$load("1audf"),
    $c14c8c21b007c47f$var$load("bpBPu"),
    $c14c8c21b007c47f$var$load("ahEIC"),
    $c14c8c21b007c47f$var$load("abBST"),
    $c14c8c21b007c47f$var$load("coGVA"),
    $c14c8c21b007c47f$var$load("RI3SR"),
    $c14c8c21b007c47f$var$load("dtNxV"),
    $c14c8c21b007c47f$var$load("jXx9i"),
    $c14c8c21b007c47f$var$load("gFeoL"),
    $c14c8c21b007c47f$var$load("kT6dz"),
    $c14c8c21b007c47f$var$load("aAWLw"),
    $c14c8c21b007c47f$var$load("7EorR"),
    $c14c8c21b007c47f$var$load("4Bg7q")
]).then(()=>parcelRequire('9ChZM'));

});

parcelRegister("3WPGR", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $75Ax4 = parcelRequire("75Ax4");


var $dkxaU = parcelRequire("dkxaU");


var $bKd7w = parcelRequire("bKd7w");

function $523f2f8bee18c451$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    try {
        value = JSON.parse(p.value);
        version = parseInt(JSON.parse(p.version.number));
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
function $523f2f8bee18c451$export$64dc6e3789165979(appearanceValue) {
    let appearance;
    if (appearanceValue) try {
        appearance = JSON.parse(appearanceValue);
    } catch (e) {
        appearance = null;
    }
    return appearance ?? (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
function $523f2f8bee18c451$export$df5897f4041f380b(contentQueryData, isLivePage) {
    const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
    const properties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes || [];
    const published = isLivePage ? properties[0] : properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
    const coverPictureWidth = contentQueryData?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(contentQueryData);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const coverPicture = {
        draft: null,
        published: $523f2f8bee18c451$export$da000b5ddbbe9afc(published)
    };
    let publishedValue;
    try {
        publishedValue = JSON.parse(pageWidthType);
    } catch (e) {
        publishedValue = 'default';
    }
    const contentAppearance = {
        draft: '',
        published: publishedValue
    };
    const hasCoverPicture = !!coverPicture?.published?.value?.id;
    return {
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        hasCoverPicture: hasCoverPicture,
        coverPictureWidth: coverPictureWidth,
        isTitleCenterAligned: isTitleCenterAligned
    };
}
const $523f2f8bee18c451$export$abc9309e623c0351 = (width)=>{
    return (0, $dkxaU.calcDynamicCoverImageHeight)(width);
};
function $523f2f8bee18c451$export$8a432f79b719eeda(imageUrl) {
    if (!imageUrl) return false;
    return imageUrl.includes('images.unsplash.com') || imageUrl.includes('dam-cdn.atl.orangelogic.com') || /^https?:\/\/wac-cdn-[^.]+\.atlassian\.com/.test(imageUrl);
}
module.exports["propertyToId"] = $523f2f8bee18c451$export$da000b5ddbbe9afc;
module.exports["getRendererCoverPictureInfo"] = $523f2f8bee18c451$export$df5897f4041f380b;
module.exports["getDynamicCoverImageHeight"] = $523f2f8bee18c451$export$abc9309e623c0351;
module.exports["isAllowedExternalCoverPictureUrl"] = $523f2f8bee18c451$export$8a432f79b719eeda;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $eB536 = parcelRequire("eB536");


var $1Y111 = parcelRequire("1Y111");


var $jtuBN = parcelRequire("jtuBN");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$e114ec4e88c7fe33 = (0, $eB536.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch  {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$var$QUERY_OPTIONS = (contentId)=>({
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const options = $20e32f1deb8c1fe0$var$QUERY_OPTIONS(contentId);
    const { data: data, error: error, loading: loading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: options.variables,
        skip: !contentId,
        __callerPackage__: "content-topper"
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["useTitleContentPropertiesForPublishedPage_content"] = $20e32f1deb8c1fe0$export$e114ec4e88c7fe33;
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<27d66eab829e89ba017f17104702246d>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("eB536", function(module, exports) {
/**
 * @generated SignedSource<<f3aa298d710112bdac45cdae3936c970>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3cc0a8cff50ad3c7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useTitleContentPropertiesForPublishedPage_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            },
            {
                "alias": "pageTitleDraft",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-draft"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-draft\")"
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$3cc0a8cff50ad3c7$var$node.hash = "6913c519b951b36b57b6c77657b055fd";
var $3cc0a8cff50ad3c7$export$2e2bcd8739ae039 = $3cc0a8cff50ad3c7$var$node;
module.exports["default"] = $3cc0a8cff50ad3c7$export$2e2bcd8739ae039;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c93173dea6bc8ed379cb4b9b29fb2a88>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("dkxaU", function(module, exports) {

var $75Ax4 = parcelRequire("75Ax4");

const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};
module.exports["calcDynamicCoverImageHeight"] = $17b31ae3aa6020db$export$6a5c726aaec5b09;

});

parcelRegister("bKd7w", function(module, exports) {
var $9558c78c09e4ba60$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
module.exports["CoverPictureIdPropertyKey"] = $9558c78c09e4ba60$export$da638b84af7eb6eb;

});

parcelRegister("fDEVM", function(module, exports) {

var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $hMdkB = parcelRequire("hMdkB");

var $9b92440f7f429369$export$1ef9fc5d7a7ef8e2 = /*#__PURE__*/ function(TYPE_OF_NODE) {
    TYPE_OF_NODE["LAYOUT"] = "layout";
    TYPE_OF_NODE["HR"] = "hr";
    TYPE_OF_NODE["EXPAND"] = "expand";
    TYPE_OF_NODE["HEADING"] = "header";
    TYPE_OF_NODE["EMPTY"] = "empty";
    TYPE_OF_NODE["OTHER"] = "other";
    TYPE_OF_NODE["STICKY_HEADER"] = "stickyHeader";
    TYPE_OF_NODE["TABLE"] = "table";
    TYPE_OF_NODE["MACRO"] = "macro";
    TYPE_OF_NODE["IMAGE"] = "image";
    return TYPE_OF_NODE;
}({});
const $9b92440f7f429369$export$be27aa1bed7edb58 = (scrollUp)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const scrollContainer = document.getElementById(`${(0, $hMdkB.PresenterModePortalContainerId)}`);
    // Scroll by half the viewport height
    const scrollAmount = window.innerHeight * 0.5 * (scrollUp ? -1 : 1);
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(()=>{
        scrollContainer?.scrollBy({
            top: scrollContainer.getBoundingClientRect().top + scrollAmount,
            behavior: 'smooth'
        });
    });
};
const $9b92440f7f429369$export$8286ea4d39e1c85c = (originalSrc)=>{
    if (!originalSrc.includes('images.unsplash.com')) return originalSrc;
    const baseAndParams = originalSrc.split('?');
    const queryParams = new URLSearchParams(baseAndParams[1]);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const width = Math.min(document?.documentElement?.clientWidth, 3000);
    queryParams.set('w', width.toString());
    queryParams.delete('q');
    return `${baseAndParams[0]}?${queryParams.toString()}`;
};
const $9b92440f7f429369$export$87b554716dce1db0 = (refNode)=>{
    const getFirstTextNodeIterative = (refNode)=>{
        const stack = [
            refNode
        ];
        while(stack.length > 0){
            const node = stack.pop();
            if (node.nodeType == 3 && node.nodeValue?.trim().length !== 0) return node;
            for(let i = node.childNodes.length - 1; i >= 0; i--)stack.push(node.childNodes[i]);
        }
    };
    return getFirstTextNodeIterative(refNode);
};
const $9b92440f7f429369$export$91dc29669e88d0db = (node)=>{
    return /^([Hh])[0-6].*/.test(node?.tagName);
};
const $9b92440f7f429369$export$dd1bc94b04021eeb = (node)=>{
    const firstTextNode = $9b92440f7f429369$export$87b554716dce1db0(node);
    if ($9b92440f7f429369$export$91dc29669e88d0db(node) && !firstTextNode) return true;
    if ($9b92440f7f429369$export$ed5642f3e4fb7c54(node)) return true;
    const isImage = node.classList.contains('rich-media-item') || !!node.querySelector('img') || !!node.querySelector('svg');
    const isEmptyTextElement = !firstTextNode;
    return !isImage && isEmptyTextElement;
};
const $9b92440f7f429369$export$fb85bc5d6d9ef19b = (node)=>{
    return node.classList.contains('rich-media-item') || !!node.querySelector('img') || !!node.querySelector('svg');
};
const $9b92440f7f429369$export$bf32d97724374086 = (node)=>{
    return !!node.querySelector('.pm-table-sticky-wrapper');
};
const $9b92440f7f429369$export$567a2801b8f40ab5 = (node)=>{
    return node.classList.contains('pm-table-container') || !!node.querySelector('.pm-table-container') && !$9b92440f7f429369$export$bf32d97724374086(node);
};
const $9b92440f7f429369$export$1980ca1f3eaf85fb = (node)=>{
    return node.getAttribute('data-layout-section') === 'true';
};
const $9b92440f7f429369$export$d8bf6fedd3b53772 = (node)=>{
    return node.tagName === 'HR';
};
const $9b92440f7f429369$export$35e907bd866058b8 = (node)=>{
    return node.classList.contains('ak-renderer-extension') || !!node.querySelector('.ak-renderer-extension');
};
const $9b92440f7f429369$export$1d7f19df4bf635f6 = (node)=>{
    return node.classList.contains('code-block') || !!node.querySelector('.code-block');
};
const $9b92440f7f429369$export$ed5642f3e4fb7c54 = (node)=>{
    return node.tagName === 'BR';
};
const $9b92440f7f429369$export$822db98f95375647 = (contentId)=>{
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)({
        contentId: contentId
    });
    return !!(titleContentProperties?.titleLayoutAlignment === (0, $jVylI.TitleAlignmentType).CENTER);
};
module.exports["TYPE_OF_NODE"] = $9b92440f7f429369$export$1ef9fc5d7a7ef8e2;
module.exports["scrollFixedAmount"] = $9b92440f7f429369$export$be27aa1bed7edb58;
module.exports["createHigherResImgSrc"] = $9b92440f7f429369$export$8286ea4d39e1c85c;
module.exports["getFirstTextNode"] = $9b92440f7f429369$export$87b554716dce1db0;
module.exports["isHeading"] = $9b92440f7f429369$export$91dc29669e88d0db;
module.exports["isEmpty"] = $9b92440f7f429369$export$dd1bc94b04021eeb;
module.exports["isImage"] = $9b92440f7f429369$export$fb85bc5d6d9ef19b;
module.exports["isStickyHeaderOfTable"] = $9b92440f7f429369$export$bf32d97724374086;
module.exports["isTable"] = $9b92440f7f429369$export$567a2801b8f40ab5;
module.exports["isLayout"] = $9b92440f7f429369$export$1980ca1f3eaf85fb;
module.exports["isHorizontalRule"] = $9b92440f7f429369$export$d8bf6fedd3b53772;
module.exports["isMacro"] = $9b92440f7f429369$export$35e907bd866058b8;
module.exports["isCodeBlock"] = $9b92440f7f429369$export$1d7f19df4bf635f6;
module.exports["useIsTitleCenterAligned"] = $9b92440f7f429369$export$822db98f95375647;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("4JC0x", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $98c2a7811aa5a89d$export$fe853ff85807a350 = new Map();
let $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
const $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState = (0, $dOBRD.default)(()=>{
    const rootQueryList = window?.__APOLLO_STATE__?.ROOT_QUERY || {};
    return Object.keys(rootQueryList).filter((query)=>query.startsWith('macroBodyRenderer'));
});
function $98c2a7811aa5a89d$var$isMacroPreloaded(macroId) {
    const preloadedMacros = $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState();
    return preloadedMacros.some((preloaded)=>preloaded.includes(macroId));
}
const $98c2a7811aa5a89d$export$1441f92d09a5c3ee = ()=>window.__SSR_RENDERED__ && !!window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__;
function $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl() {
    const cacheMismatches = $98c2a7811aa5a89d$var$getPreloadCacheMismatches();
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (cacheMismatches.length == 0 && (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0)) return;
    const failedMacros = {};
    function addFailed(reason, macroId, extensionKey) {
        failedMacros[macroId] = {
            reason: reason,
            extensionKey: extensionKey
        };
    }
    Object.entries(reportedFails).forEach(([keyAndId, reason])=>{
        if (keyAndId === 'general') return;
        const [extensionKey, macroId] = keyAndId.split(':');
        if (reason === 'timeout') {
            if ($98c2a7811aa5a89d$var$isMacroPreloaded(macroId)) addFailed('falseTimeouts', macroId, extensionKey);
            else addFailed('trueTimeouts', macroId, extensionKey);
        } else addFailed(reason, macroId, extensionKey);
    });
    cacheMismatches.forEach(([macroId, extensionKey])=>addFailed('cacheMismatch', macroId, extensionKey));
    return failedMacros;
}
function $98c2a7811aa5a89d$export$622ff65a4d6eaaaf() {
    if (!$98c2a7811aa5a89d$export$576fafc5561e06f5) $98c2a7811aa5a89d$export$576fafc5561e06f5 = {
        value: $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl()
    };
    return $98c2a7811aa5a89d$export$576fafc5561e06f5.value;
}
function $98c2a7811aa5a89d$export$de5406af81980582() {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
}
function $98c2a7811aa5a89d$export$3288a79f0c713f52(macroId) {
    const failedMacros = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf();
    return failedMacros?.[macroId]?.reason;
}
function $98c2a7811aa5a89d$export$34734b475a3fd7b9() {
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0) return;
    return reportedFails?.['general'];
}
function $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd(macroId, extensionKey) {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
    $98c2a7811aa5a89d$export$fe853ff85807a350.set(macroId, extensionKey || '');
    window['__MISSING_DATA_MACROS__'] = window['__MISSING_DATA_MACROS__'] || [];
    window['__MISSING_DATA_MACROS__'].push(macroId);
}
function $98c2a7811aa5a89d$var$getPreloadCacheMismatches() {
    return [
        ...$98c2a7811aa5a89d$export$fe853ff85807a350
    ].filter(([macroId])=>$98c2a7811aa5a89d$var$isMacroPreloaded(macroId));
}
module.exports["macrosPreloadPerformed"] = $98c2a7811aa5a89d$export$1441f92d09a5c3ee;
module.exports["getPreloadFailedMacros"] = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf;
module.exports["getPreloadFailures"] = $98c2a7811aa5a89d$export$3288a79f0c713f52;
module.exports["getGeneralFailures"] = $98c2a7811aa5a89d$export$34734b475a3fd7b9;
module.exports["markMissingMacroData"] = $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $e6fvz = parcelRequire("e6fvz");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$export$75d6c00965e77c = (0, $e6fvz.default);
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery,
        __callerPackage__: "onboarding-helpers"
    });
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("e6fvz", function(module, exports) {
/**
 * @generated SignedSource<<0c17cade527e0c98b3a6d07d61bdb0ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6eba286460e57a30$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "onboardingState_state",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ],
    "type": "OnboardingState"
};
$6eba286460e57a30$var$node.hash = "4458ec6e78736741d79615a29b68de83";
var $6eba286460e57a30$export$2e2bcd8739ae039 = $6eba286460e57a30$var$node;
module.exports["default"] = $6eba286460e57a30$export$2e2bcd8739ae039;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$9df55620e365effa = ()=>{
    const { isLoggedIn: isLoggedIn, hasConfluenceUser: hasConfluenceUser } = (0, $bQm3c.useSessionData)();
    return isLoggedIn && !hasConfluenceUser;
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useIsAuthenticatedWithoutConfluenceUser"] = $30f02aa82d7102bc$export$9df55620e365effa;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("cbOce", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("dBcar", function(module, exports) {

var $5AFnD = parcelRequire("5AFnD");

const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804),
    (0, $5AFnD.LOOM_NUDGE_REMIND_ME),
    (0, $5AFnD.LOOM_NUDGE_LAST_SHOWN_AT)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("5AFnD", function(module, exports) {
const $00e2d16f0c5935d6$export$477408ab8b02b670 = 'twcg-2202-loom-nudge:remindMe';
const $00e2d16f0c5935d6$export$c98b33a7293cedf4 = 'twcg-2202-loom-nudge:lastShownAt';
module.exports["LOOM_NUDGE_REMIND_ME"] = $00e2d16f0c5935d6$export$477408ab8b02b670;
module.exports["LOOM_NUDGE_LAST_SHOWN_AT"] = $00e2d16f0c5935d6$export$c98b33a7293cedf4;

});

parcelRegister("6Q8Dd", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $4fae4b715d22864c$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $4fae4b715d22864c$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $4fae4b715d22864c$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $4fae4b715d22864c$var$getValidCacheKeyFn(options);
        this._cacheMap = $4fae4b715d22864c$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $4fae4b715d22864c$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $4fae4b715d22864c$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$4fae4b715d22864c$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $4fae4b715d22864c$var$enqueuePostPromiseJob = typeof $1P2f3 === 'object' && typeof $1P2f3.nextTick === 'function' ? function(fn) {
    if (!$4fae4b715d22864c$var$resolvedPromise) $4fae4b715d22864c$var$resolvedPromise = Promise.resolve();
    $4fae4b715d22864c$var$resolvedPromise.then(function() {
        $1P2f3.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $4fae4b715d22864c$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $4fae4b715d22864c$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $4fae4b715d22864c$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $4fae4b715d22864c$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $4fae4b715d22864c$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$4fae4b715d22864c$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $4fae4b715d22864c$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $4fae4b715d22864c$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $4fae4b715d22864c$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $4fae4b715d22864c$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $4fae4b715d22864c$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $4fae4b715d22864c$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $4fae4b715d22864c$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $4fae4b715d22864c$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $4fae4b715d22864c$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $4fae4b715d22864c$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $4fae4b715d22864c$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $4fae4b715d22864c$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $4fae4b715d22864c$var$DataLoader;

});

parcelRegister("lPEt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
}); //# sourceMappingURL=lru.js.map

});

parcelRegister("fh15z", function(module, exports) {

var $3Ww6H = parcelRequire("3Ww6H");


var $cNAch = parcelRequire("cNAch");

class $235e9e63ec7037ae$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $cNAch.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $3Ww6H.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}
module.exports["ConcurrentExperience"] = $235e9e63ec7037ae$export$ac1cddfee07ba6ac;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("kOUwv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $8s9DV.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $kBr4q.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $kBr4q.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("3jjX7", function(module, exports) {
// WARNING: This value is shared between @atlaskit/analytics-cross-product and
// @atlassiansox/analytics-cross-product-interaction-client. Take care when updating.
const $6e6234f2764332e7$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $6e6234f2764332e7$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($6e6234f2764332e7$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$6e6234f2764332e7$export$7bc189309d2ad463];
        } catch (err) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}
module.exports["default"] = $6e6234f2764332e7$export$2e2bcd8739ae039;

});

parcelRegister("cuWGz", function(module, exports) {

var $e66dL = parcelRequire("e66dL");


var $aO6uT = parcelRequire("aO6uT");

function $61987beec044a597$export$57570b1603cf6adb(env) {
    if (env) return env;
    if (typeof window === 'undefined' || !window.location) return (0, $aO6uT.Environment).Unknown;
    const host = window.location.hostname.toLowerCase();
    // Fast path: exact hostname matches
    const exactMatch = (0, $e66dL.EXACT_HOST_MAP)[host];
    if (exactMatch) return exactMatch;
    // Extract TLD for efficient branching (find last dot position)
    const lastDot = host.lastIndexOf('.');
    if (lastDot === -1) return (0, $aO6uT.Environment).Unknown;
    const tld = host.slice(lastDot + 1); // 'com', 'net', etc.
    // Branch by TLD to reduce checks
    switch(tld){
        case 'com':
            return $61987beec044a597$var$classifyComDomain(host);
        case 'net':
            return $61987beec044a597$var$classifyNetDomain(host);
        default:
            return (0, $aO6uT.Environment).Unknown;
    }
}
/**
 * Classify .com domains
 */ function $61987beec044a597$var$classifyComDomain(host) {
    // jira-dev.com (staging)
    if (host.endsWith('.jira-dev.com')) return (0, $aO6uT.Environment).Staging;
    // atlassian-us-gov-mod.com (FedRAMP)
    if (host.endsWith('.atlassian-us-gov-mod.com')) {
        // FedRAMP Bifrost CDN: check most specific first
        if (host.endsWith('.frontend.cdn.atlassian-us-gov-mod.com')) return host.includes('.stg.') ? (0, $aO6uT.Environment).Staging : (0, $aO6uT.Environment).Prod;
        if (host.endsWith('.stg.atlassian-us-gov-mod.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    // atlassian.com domains
    if (host.endsWith('.atlassian.com')) {
        // services.atlassian.com vanity domains (check most specific first)
        if (host.endsWith('.dev.services.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.staging.services.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        if (host.endsWith('.services.atlassian.com')) return (0, $aO6uT.Environment).Prod;
        // Environment-specific subdomains
        if (host.endsWith('.dev.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.stg.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
/**
 * Classify .net domains
 */ function $61987beec044a597$var$classifyNetDomain(host) {
    // atlassian.net (prod tenants)
    if (host.endsWith('.atlassian.net')) return (0, $aO6uT.Environment).Prod;
    // atl-paas-us-gov-mod.net (FedRAMP Micros)
    if (host.endsWith('.atl-paas-us-gov-mod.net')) {
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
        return (0, $aO6uT.Environment).Unknown;
    }
    // atl-paas.net (commercial Micros and Bifrost)
    if (host.endsWith('.atl-paas.net')) {
        // Bifrost commercial: check most specific first
        if (host.endsWith('.frontend.public.atl-paas.net')) {
            if (host.includes('.ddev.') || host.includes('.dev-west2.')) return (0, $aO6uT.Environment).Development;
            if (host.includes('.stg-east.')) return (0, $aO6uT.Environment).Staging;
            if (host.includes('.prod-east.')) return (0, $aO6uT.Environment).Prod;
            return (0, $aO6uT.Environment).Development;
        }
        // Micros commercial
        if (host.includes('.dev.') || host.includes('.platdev.')) return (0, $aO6uT.Environment).Development;
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
module.exports["getEnvironment"] = $61987beec044a597$export$57570b1603cf6adb;

});

parcelRegister("e66dL", function(module, exports) {

var $aO6uT = parcelRequire("aO6uT");

const $1c6adf460a912312$export$636c0c57a2ce36e9 = {
    localhost: (0, $aO6uT.Environment).Development,
    '127.0.0.1': (0, $aO6uT.Environment).Development,
    'id.atlassian.com': (0, $aO6uT.Environment).Prod,
    'admin.atlassian.com': (0, $aO6uT.Environment).Prod,
    'id.stg.internal.atlassian.com': (0, $aO6uT.Environment).Staging,
    'admin.stg.atlassian.com': (0, $aO6uT.Environment).Staging
};
module.exports["EXACT_HOST_MAP"] = $1c6adf460a912312$export$636c0c57a2ce36e9;

});

parcelRegister("aO6uT", function(module, exports) {
var $cf10c8edb5d48b94$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    Environment["Unknown"] = "unknown";
    return Environment;
}({});
module.exports["Environment"] = $cf10c8edb5d48b94$export$7dc6752a22ab011a;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("gXrHX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("1P7Cq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $5c11702222c9ae97$export$10d6d9579eb80191 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const includeNonHydratingInitialRender = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [isSSROrHydrating, setIsSSROrHydrating] = (0, $cozmU.useState)(includeNonHydratingInitialRender ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            {
                if (window.__SSR_RENDERED__) (0, $cozmU.startTransition)(()=>{
                    setIsSSROrHydrating(false);
                });
                else setIsSSROrHydrating(false);
            }
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isSSROrHydrating;
};
module.exports["useIsSSROrHydrating"] = $5c11702222c9ae97$export$10d6d9579eb80191;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $gXfti.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("7bpSh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9dee672aff5abe3d$export$c4ffab2abecc9a7c = (0, $cozmU.createContext)(null);
module.exports["ContentModeFragmentContext"] = $9dee672aff5abe3d$export$c4ffab2abecc9a7c;

});

parcelRegister("hl0fg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

const $9b206d933744c82f$export$42c02f33970a2afa = ()=>{
    const isClient = typeof window === 'object';
    const getSize = ()=>{
        return {
            width: isClient ? window.innerWidth : 0,
            height: isClient ? window.innerHeight : 0
        };
    };
    const [windowSize, setWindowSize] = (0, $cozmU.useState)(getSize);
    (0, $cozmU.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setWindowSize(getSize());
        }, 200);
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            handleResize.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
module.exports["useWindowSize"] = $9b206d933744c82f$export$42c02f33970a2afa;

});

parcelRegister("3Xfhj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bf3492583e212e7a$export$cf8a0a38543b2f6c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EfLS5",
    loader: async ()=>(await (parcelRequire("7ow4x"))).PageContentRendererFabric,
    name: 'PageContentRendererFabric'
});

const $bf3492583e212e7a$export$43e0568dbf658f88 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VZbpe",
    loader: async ()=>(await (parcelRequire("5WFRb"))).PageContentRendererTiny,
    name: 'PageContentRendererTiny'
});
module.exports["PageContentRendererFabric"] = $bf3492583e212e7a$export$cf8a0a38543b2f6c;
module.exports["PageContentRendererTiny"] = $bf3492583e212e7a$export$43e0568dbf658f88;

});

parcelRegister("7ow4x", function(module, exports) {

let $5623a72401025e73$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5623a72401025e73$var$load("kT6dz"),
    $5623a72401025e73$var$load("46Rej"),
    $5623a72401025e73$var$load("50xKF"),
    $5623a72401025e73$var$load("8dKKv"),
    $5623a72401025e73$var$load("5wjYh"),
    $5623a72401025e73$var$load("jo0Tg"),
    $5623a72401025e73$var$load("2hPbk"),
    $5623a72401025e73$var$load("icYyL"),
    $5623a72401025e73$var$load("6Qybl"),
    $5623a72401025e73$var$load("4PCFY"),
    $5623a72401025e73$var$load("fxlto"),
    $5623a72401025e73$var$load("2F69B"),
    $5623a72401025e73$var$load("53Y0O"),
    $5623a72401025e73$var$load("kYlwR"),
    $5623a72401025e73$var$load("iDzF1"),
    $5623a72401025e73$var$load("lKZDc"),
    $5623a72401025e73$var$load("bqdgP"),
    $5623a72401025e73$var$load("aVpwX"),
    $5623a72401025e73$var$load("dEA3e"),
    $5623a72401025e73$var$load("7SteV"),
    $5623a72401025e73$var$load("eOWoJ"),
    $5623a72401025e73$var$load("4aKct"),
    $5623a72401025e73$var$load("6dLts"),
    $5623a72401025e73$var$load("jdPbE"),
    $5623a72401025e73$var$load("eUsnQ"),
    $5623a72401025e73$var$load("khIi2"),
    $5623a72401025e73$var$load("eEjUf"),
    $5623a72401025e73$var$load("1ET6p"),
    $5623a72401025e73$var$load("bQgoi"),
    $5623a72401025e73$var$load("ea3NB"),
    $5623a72401025e73$var$load("dxcsb"),
    $5623a72401025e73$var$load("6wr18"),
    $5623a72401025e73$var$load("59hV4"),
    $5623a72401025e73$var$load("lrmeP"),
    $5623a72401025e73$var$load("6fY3H"),
    $5623a72401025e73$var$load("dtNxV"),
    $5623a72401025e73$var$load("cGkFm"),
    $5623a72401025e73$var$load("aqMLH"),
    $5623a72401025e73$var$load("ctdyb"),
    $5623a72401025e73$var$load("a7sEM"),
    $5623a72401025e73$var$load("ffEVr"),
    $5623a72401025e73$var$load("a6kGP"),
    $5623a72401025e73$var$load("dB5kj"),
    $5623a72401025e73$var$load("ckVWI"),
    $5623a72401025e73$var$load("2dYOx"),
    $5623a72401025e73$var$load("5RJ9W"),
    $5623a72401025e73$var$load("1audf"),
    $5623a72401025e73$var$load("bpBPu"),
    $5623a72401025e73$var$load("ahEIC"),
    $5623a72401025e73$var$load("hkiCw"),
    $5623a72401025e73$var$load("gFeoL"),
    $5623a72401025e73$var$load("Wowvf"),
    $5623a72401025e73$var$load("4g6rd"),
    $5623a72401025e73$var$load("17aNV"),
    $5623a72401025e73$var$load("fWCBZ"),
    $5623a72401025e73$var$load("abBST"),
    $5623a72401025e73$var$load("2nsSd"),
    $5623a72401025e73$var$load("hhss7"),
    $5623a72401025e73$var$load("hsNN2"),
    $5623a72401025e73$var$load("2IeKu"),
    $5623a72401025e73$var$load("7EorR"),
    $5623a72401025e73$var$load("kNILH")
]).then(()=>parcelRequire('8ThhQ'));

});

parcelRegister("5WFRb", function(module, exports) {

let $4542d66938908ee7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4542d66938908ee7$var$load("57TcR"),
    $4542d66938908ee7$var$load("4g6rd"),
    $4542d66938908ee7$var$load("17aNV"),
    $4542d66938908ee7$var$load("j3lvX"),
    $4542d66938908ee7$var$load("bm0oR"),
    $4542d66938908ee7$var$load("30b92"),
    $4542d66938908ee7$var$load("1ET6p"),
    $4542d66938908ee7$var$load("bQgoi"),
    $4542d66938908ee7$var$load("ea3NB"),
    $4542d66938908ee7$var$load("6wr18"),
    $4542d66938908ee7$var$load("59hV4"),
    $4542d66938908ee7$var$load("fuOfV"),
    $4542d66938908ee7$var$load("jL1Ke"),
    $4542d66938908ee7$var$load("5MQ0D"),
    $4542d66938908ee7$var$load("ffEVr"),
    $4542d66938908ee7$var$load("5gsbh"),
    $4542d66938908ee7$var$load("1audf"),
    $4542d66938908ee7$var$load("bpBPu"),
    $4542d66938908ee7$var$load("fwbNS"),
    $4542d66938908ee7$var$load("1T63O"),
    $4542d66938908ee7$var$load("h4Nf7"),
    $4542d66938908ee7$var$load("Wowvf"),
    $4542d66938908ee7$var$load("fWCBZ"),
    $4542d66938908ee7$var$load("hhss7"),
    $4542d66938908ee7$var$load("7EorR"),
    $4542d66938908ee7$var$load("e9VVN")
]).then(()=>parcelRequire('ixmFo'));

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.scrollingElement || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.body.appendChild(el);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("d3MrN", function(module, exports) {
var $982122d42c7c3a7b$var$key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5,
    fullscreen: 6
};
var $982122d42c7c3a7b$var$webkit = [
    'webkitFullscreenEnabled',
    'webkitFullscreenElement',
    'webkitRequestFullscreen',
    'webkitExitFullscreen',
    'webkitfullscreenchange',
    'webkitfullscreenerror',
    '-webkit-full-screen'
];
var $982122d42c7c3a7b$var$moz = [
    'mozFullScreenEnabled',
    'mozFullScreenElement',
    'mozRequestFullScreen',
    'mozCancelFullScreen',
    'mozfullscreenchange',
    'mozfullscreenerror',
    '-moz-full-screen'
];
var $982122d42c7c3a7b$var$ms = [
    'msFullscreenEnabled',
    'msFullscreenElement',
    'msRequestFullscreen',
    'msExitFullscreen',
    'MSFullscreenChange',
    'MSFullscreenError',
    '-ms-fullscreen'
];
// so it doesn't throw if no window or document
var $982122d42c7c3a7b$var$document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
var $982122d42c7c3a7b$var$vendor = 'fullscreenEnabled' in $982122d42c7c3a7b$var$document && Object.keys($982122d42c7c3a7b$var$key) || $982122d42c7c3a7b$var$webkit[0] in $982122d42c7c3a7b$var$document && $982122d42c7c3a7b$var$webkit || $982122d42c7c3a7b$var$moz[0] in $982122d42c7c3a7b$var$document && $982122d42c7c3a7b$var$moz || $982122d42c7c3a7b$var$ms[0] in $982122d42c7c3a7b$var$document && $982122d42c7c3a7b$var$ms || [];
var $982122d42c7c3a7b$var$fscreen = {
    requestFullscreen: function(element) {
        return element[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.requestFullscreen]]();
    },
    requestFullscreenFunction: function(element) {
        return element[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.requestFullscreen]];
    },
    get exitFullscreen () {
        return $982122d42c7c3a7b$var$document[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.exitFullscreen]].bind($982122d42c7c3a7b$var$document);
    },
    get fullscreenPseudoClass () {
        return ":" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreen];
    },
    addEventListener: function(type, handler1, options) {
        return $982122d42c7c3a7b$var$document.addEventListener($982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key[type]], handler1, options);
    },
    removeEventListener: function(type, handler1, options) {
        return $982122d42c7c3a7b$var$document.removeEventListener($982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key[type]], handler1, options);
    },
    get fullscreenEnabled () {
        return Boolean($982122d42c7c3a7b$var$document[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenEnabled]]);
    },
    set fullscreenEnabled (val){},
    get fullscreenElement () {
        return $982122d42c7c3a7b$var$document[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenElement]];
    },
    set fullscreenElement (val){},
    get onfullscreenchange () {
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenchange]).toLowerCase()];
    },
    set onfullscreenchange (handler){
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenchange]).toLowerCase()] = handler;
    },
    get onfullscreenerror () {
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenerror]).toLowerCase()];
    },
    set onfullscreenerror (handler){
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenerror]).toLowerCase()] = handler;
    }
};
var $982122d42c7c3a7b$export$2e2bcd8739ae039 //# sourceMappingURL=fscreen.esm.js.map
 = $982122d42c7c3a7b$var$fscreen;
module.exports["default"] = $982122d42c7c3a7b$export$2e2bcd8739ae039;

});


//# sourceMappingURL=PresenterModeContextProvider.b8b3464a.js.map
